import { useNavigate } from "react-router-dom"
import Header from "../components/Header"

export default function NotFound() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-11 flex flex-col items-center justify-center min-h-[80vh] px-4 text-center">
        <span className="font-display text-[120px] sm:text-[180px] leading-none font-semibold text-primary-darker/10 select-none">
          404
        </span>
        <h1 className="font-display text-[28px] sm:text-[40px] font-semibold text-black -mt-4">
          Página não encontrada
        </h1>
        <p className="mt-4 font-sans text-sm sm:text-base text-black/50 max-w-sm">
          A página que você está procurando não existe ou foi removida.
        </p>
        <button
          onClick={() => navigate("/")}
          className="mt-8 font-sans font-bold inline-flex h-10 sm:h-12 items-center justify-center rounded-full bg-primary-darker px-6 sm:px-8 text-sm sm:text-base text-white shadow-lg transition hover:bg-primary"
        >
          Voltar ao início
        </button>
      </main>
    </div>
  )
}
